import 'bootstrap/dist/css/bootstrap.css';
// Adobe Museo Slab
import './hbo5hsa.css';
import './index.css';
import './IonIcons/ionicons.min.css';
import './styles.scss.css';
